import React from 'react';
import logoImg from '../../img/logo-new.png';
import styled from 'styled-components';
import { Props } from './interface';

const Container = styled.div<{ alignSelf?: Props['alignSelf'] }>`
  flex: none;
  display: inline-flex;
  align-self: ${props => props.alignSelf};
  width: 120px;
  height: 120px;
  padding: 16px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Logo = (props: Props) => {
  const { alignSelf } = props;

  return (
    <Container alignSelf={alignSelf}>
      <img alt='ECOS logo' src={logoImg} />
    </Container>
  );
};

export default Logo;
